import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { Utilities } from '../../../utilities/utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'smr-calendar-date-picker',
  templateUrl: './calendar-date-picker.component.html',
  styleUrls: ['./calendar-date-picker.component.scss'],
})
export class CalendarDatePickerComponent implements OnInit {
  @ViewChild(IonSlides) slides: IonSlides;
  slideOpts = {
    initialSlide: 1,
  };

  public DayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  @Input() selectedDate: Date;
  public today: Date;
  public calendarWeekList;
  public prevCalendarDateList: Array<Date>;
  public calendarDateList: Array<Date>;
  public nextCalendarDateList: Array<Date>;
  @Output() newSelectedDate = new EventEmitter();
  firstLoad = true;
  constructor() {
    this.today = new Date();
  }

  ngOnInit() {
    this.generateCalendarDates(this.selectedDate);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.generateCalendarDates(this.selectedDate);
  }

  public generateCalendarDates(selectedDate) {
    this.prevCalendarDateList = [];
    this.calendarDateList = [];
    this.nextCalendarDateList = [];
    var dayOfSelectedDate = selectedDate.getDay();
    for (var i = 0 - dayOfSelectedDate; i < 7 - dayOfSelectedDate; i++) {
      this.prevCalendarDateList.push(
        Utilities.addDays(this.selectedDate, i - 7)
      );
      this.calendarDateList.push(Utilities.addDays(this.selectedDate, i));
      this.nextCalendarDateList.push(
        Utilities.addDays(this.selectedDate, i + 7)
      );
    }
    this.calendarWeekList = [
      this.prevCalendarDateList,
      this.calendarDateList,
      this.nextCalendarDateList,
    ];
  }



    
  

 loadPrev() {
    var dayOfSelectedDate = Utilities.subtractDays(this.selectedDate, 7).getDay();
    this.selectDate(Utilities.subtractDays(this.selectedDate, 7));

    let newDateList = []
    for (var i = 0 - dayOfSelectedDate; i < 7 - dayOfSelectedDate; i++) {
      newDateList.push(
        Utilities.addDays(this.selectedDate, i - 7)
      );
    }

    this.calendarWeekList.unshift(newDateList);
    this.calendarWeekList.pop();
    // this.swiperRef.swiperRef.slideTo(1, 0, false)
    this.slides.slideTo(1, 0, false);

  }

 loadNext() {

    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    var dayOfSelectedDate = Utilities.addDays(this.selectedDate, 7).getDay();
    this.selectDate(Utilities.addDays(this.selectedDate, 7));

    let newDateList = []
    for (var i = 0 - dayOfSelectedDate; i < 7 - dayOfSelectedDate; i++) {
      newDateList.push(
        Utilities.addDays(this.selectedDate, i - 7)
      );
    }

    this.calendarWeekList.push(newDateList);
    this.calendarWeekList.shift();
    // this.swiperRef.swiperRef.slideTo(1, 0, false)
    this.slides.slideTo(1, 0, false);

  }


  public selectDate(date) {
    this.selectedDate = date;
    this.newSelectedDate.emit(date);
  }

  compareDate(date1, date2) {
    if (
      date1.getYear() == date2.getYear() &&
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate()
    )
      return true;
    return false;
  }
}
